<template>
<!-- ### $Topbar ### -->
<div class="header navbar">
    <div class="header-container">
        <ul class="nav-left" id="sidebar-toggle">
            <li>
                <a class="sidebar-toggle" href="javascript:addClass('app','is-collapsed');"><i class="ti-menu"></i></a>
            </li>  
        </ul>
        <nav aria-label="breadcrumb" class="nav-left">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" v-for="(item, index) in $route.matched" :key="index" :class="{'c-grey-900': index == $route.matched.length - 1}">{{ item.meta.title }}</li>
                <li class="mL-5"><span class="badge badge-pill lh-0 p-10 fw-500" :class="versionCls" style="font-size:100%;">{{this.version}}</span></li>
                <li class="mL-5" v-if="buyUrl"><a :href="buyUrl" target="_blank" class="badge badge-pill badge-success lh-0 p-10 fw-500" style="font-size:100%;">{{$Lang('去购买')}}</a></li>
            </ol>
        </nav>
        <ul class="nav-right">
            <!-- <li class="notifications dropdown">
                <span class="counter bgc-red">3</span>
                <a href="" class="dropdown-toggle no-after" data-toggle="dropdown">
                    <i class="ti-bell"></i>
                </a>
                <ul class="dropdown-menu">
                    <li class="pX-20 pY-15 bdB">
                        <i class="ti-bell pR-10"></i>
                        <span class="fsz-sm fw-600 c-grey-900">Notifications</span></li>
                    <li>
                        <ul class="ovY-a pos-r scrollable lis-n p-0 m-0 fsz-sm">
                            <li>
                                <a href="" class='peers fxw-nw td-n p-20 bdB c-grey-800 cH-blue bgcH-grey-100'>
                                    <div class="peer mR-15">
                                        <img class="w-3r bdrs-50p" src="https://randomuser.me/api/portraits/men/1.jpg" alt=""></div>
                                    <div class="peer peer-greed">
                                        <span>
                                            <span class="fw-500">1111</span>
                                            <span class="c-grey-600">liked your
                                                <span class="text-dark">post</span></span>
                                        </span>
                                        <p class="m-0">
                                            <small class="fsz-xs">5 mins ago</small></p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="" class='peers fxw-nw td-n p-20 bdB c-grey-800 cH-blue bgcH-grey-100'>
                                    <div class="peer mR-15">
                                        <img class="w-3r bdrs-50p" src="https://randomuser.me/api/portraits/men/2.jpg" alt=""></div>
                                    <div class="peer peer-greed">
                                        <span>
                                            <span class="fw-500">Moo Doe</span>
                                            <span class="c-grey-600">liked your
                                                <span class="text-dark">cover image</span></span>
                                        </span>
                                        <p class="m-0">
                                            <small class="fsz-xs">7 mins ago</small></p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="" class='peers fxw-nw td-n p-20 bdB c-grey-800 cH-blue bgcH-grey-100'>
                                    <div class="peer mR-15">
                                        <img class="w-3r bdrs-50p" src="https://randomuser.me/api/portraits/men/3.jpg" alt=""></div>
                                    <div class="peer peer-greed">
                                        <span>
                                            <span class="fw-500">Lee Doe</span>
                                            <span class="c-grey-600">commented on your
                                                <span class="text-dark">video</span></span>
                                        </span>
                                        <p class="m-0">
                                            <small class="fsz-xs">10 mins ago</small></p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="pX-20 pY-15 ta-c bdT">
                        <span>
                            <a href="" class="c-grey-600 cH-blue fsz-sm td-n">View All Notifications
                                <i class="ti-angle-right fsz-xs mL-10"></i></a>
                        </span>
                    </li>
                </ul>
            </li>
            <li class="notifications dropdown">
                <span class="counter bgc-blue">3</span>
                <a href="" class="dropdown-toggle no-after" data-toggle="dropdown">
                    <i class="ti-email"></i>
                </a>
                <ul class="dropdown-menu">
                    <li class="pX-20 pY-15 bdB">
                        <i class="ti-email pR-10"></i>
                        <span class="fsz-sm fw-600 c-grey-900">Emails</span></li>
                    <li>
                        <ul class="ovY-a pos-r scrollable lis-n p-0 m-0 fsz-sm">
                            <li>
                                <a href="" class='peers fxw-nw td-n p-20 bdB c-grey-800 cH-blue bgcH-grey-100'>
                                    <div class="peer mR-15">
                                        <img class="w-3r bdrs-50p" src="https://randomuser.me/api/portraits/men/1.jpg" alt=""></div>
                                    <div class="peer peer-greed">
                                        <div>
                                            <div class="peers jc-sb fxw-nw mB-5">
                                                <div class="peer">
                                                    <p class="fw-500 mB-0">John Doe</p></div>
                                                <div class="peer">
                                                    <small class="fsz-xs">5 mins ago</small></div>
                                            </div>
                                            <span class="c-grey-600 fsz-sm">Want to create your own customized data generator for your app...</span></div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="" class='peers fxw-nw td-n p-20 bdB c-grey-800 cH-blue bgcH-grey-100'>
                                    <div class="peer mR-15">
                                        <img class="w-3r bdrs-50p" src="https://randomuser.me/api/portraits/men/2.jpg" alt=""></div>
                                    <div class="peer peer-greed">
                                        <div>
                                            <div class="peers jc-sb fxw-nw mB-5">
                                                <div class="peer">
                                                    <p class="fw-500 mB-0">Moo Doe</p></div>
                                                <div class="peer">
                                                    <small class="fsz-xs">15 mins ago</small></div>
                                            </div>
                                            <span class="c-grey-600 fsz-sm">Want to create your own customized data generator for your app...</span></div>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="" class='peers fxw-nw td-n p-20 bdB c-grey-800 cH-blue bgcH-grey-100'>
                                    <div class="peer mR-15">
                                        <img class="w-3r bdrs-50p" src="https://randomuser.me/api/portraits/men/3.jpg" alt=""></div>
                                    <div class="peer peer-greed">
                                        <div>
                                            <div class="peers jc-sb fxw-nw mB-5">
                                                <div class="peer">
                                                    <p class="fw-500 mB-0">Lee Doe</p></div>
                                                <div class="peer">
                                                    <small class="fsz-xs">25 mins ago</small></div>
                                            </div>
                                            <span class="c-grey-600 fsz-sm">Want to create your own customized data generator for your app...</span></div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="pX-20 pY-15 ta-c bdT">
                        <span>
                            <a href="email.html" class="c-grey-600 cH-blue fsz-sm td-n">View All Email
                                <i class="fs-xs ti-angle-right mL-10"></i></a>
                        </span>
                    </li>
                </ul>
            </li> -->
            <li class="dropdown">
                <Dropdown class="d-ib">
                <a class="no-after peers fxw-nw ai-c lh-1 cur-p" slot="buttom" style="margin-top: 1em;">
                    <div class="peer mR-10">
                        <i class="fa fa-user-circle c-blue-500" style="font-size: 2.5em"></i></div>
                    <div class="peer">
                        <span class="fsz-sm c-grey-900 shop-name">{{ shopName }}</span>
                        &nbsp;<i class="ti-angle-down fsz-xs"></i>
                    </div>
                </a>
                <ul class="dropdown-menu fsz-sm mR-5">
                    <li>
                        <a @mousedown.prevent="goTo('settingShop')" class="d-b td-n pY-5 bgcH-grey-100 c-grey-700 cur-p">
                            <i class="ti-user mR-10"></i>
                            <span>{{ $Lang('店铺资料') }}</span></a>
                    </li>
                    <li role="separator" class="divider mY-5"></li>
                    <li>
                        <a @mousedown.prevent="logout" class="d-b td-n pY-5 bgcH-grey-100 c-grey-700 cur-p">
                            <i class="ti-power-off mR-10"></i>
                            <span>{{ $Lang('退出') }}</span></a>
                    </li>
                </ul>
                </Dropdown>
            </li>
        </ul>
    </div>
</div>
</template>

<script>
    import shopApi from '@/api/shop';
    export default {
        name: 'topbar',
        watch: {
            'shopInfo': function (val) {
                let shopInfo = val;
                this.shopName = shopInfo.shop_name;
                let now = (new Date() / 1000 | 0);
                let _dis = Number(shopInfo.shop_expired) - Number(now);
                let _leftDay = Math.floor(_dis / 86400);
                if (Number(shopInfo.is_vip) === 1) {
                    if (_leftDay > 30) {
                        this.version = this.$Lang('专业版');
                        this.versionCls = 'badge-success';
                    } else if (_leftDay < 0) {
                        this.version = this.$Lang('已过期');
                        this.versionCls = 'badge-danger';
                    } else {
                        this.version = this.$Lang('剩余') + _leftDay + this.$Lang('天');
                        this.versionCls = 'badge-warning';
                    }
                } else {
                    if (_leftDay < 0) {
                        this.version = this.$Lang('试用过期');
                        this.versionCls = 'badge-danger';
                    } else if (_leftDay > 30) {
                        this.version = this.$Lang('试用版');
                        this.versionCls = 'badge-info';
                    } else {
                        this.versionCls = 'badge-warning';
                        this.version = this.$Lang('试用剩余') + _leftDay + this.$Lang('天');
                    }
                }
                // 剩余时间小于30天，则提示购买
                if (_leftDay <= 30) {
                    let apiUrl = window._getApiBaseUrl();
                    this.buyUrl = apiUrl.replace('/api', '/mall/web/cart/updataShop?shop_id=') + shopInfo.shop_id;
                }
            }
        },
        created () {
            this.getShopInfo();
        },
        methods: {
            getShopInfo () {
                shopApi.getShopInfo().then(response => {
                    if (response.data.status === 'succ') {
                        let _data = response.data.data;
                        this.shopInfo = _data;
                    }
                })
            },
            goTo (name) {
                this.$router.push({ name: name })
            },
            logout () {
                this.$store.dispatch('LogOut').then(data => {
                    this.$router.push({ name: 'signin' })
                })
            }
        },
        data () {
            return {
                shopInfo: null,
                buyUrl: '',
                shopName: '',
                version: '',
                versionCls: 'badge-success'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/layout/Topbar.vue